export const frontmatter = {
    "draft": false,
    "title": "Guide: Templates",
    "description": "How to create and manage WhatsApp templates in OnnIA: components, dynamic variables, approval states, and recommendations.",
    "sidebar_label": "Templates",
    "sidebar_group": "reference",
    "sidebar_order": 6
}

export const toc = [
    {
        "depth": 2,
        "id": "accessing-the-module",
        "value": "Accessing the module"
    },
    {
        "depth": 2,
        "id": "create-a-template",
        "value": "Create a template"
    },
    {
        "depth": 3,
        "id": "general-data-and-sending-configuration",
        "value": "General data and sending configuration"
    },
    {
        "depth": 3,
        "id": "components-blocks",
        "value": "Components (Blocks)"
    },
    {
        "depth": 2,
        "id": "template-states",
        "value": "Template states"
    },
    {
        "depth": 2,
        "id": "recommendations",
        "value": "Recommendations"
    }
]